import { i18n } from "../src/plugins/i18n";

const content = {
  tabs: [
    {
      value: "ActiveAlerts",
      label: "Active Alerts",
    },
    {
      value: "ManageAlerts",
      label: "Manage Alerts",
    },
  ],
  LocationCategory: ["", "Depot", "Distributor", "Customer"],
  TriggerField: [
    {
      label: "Total Assets",
      value: "TotalAssets",
    },
    {
      label: "Static Assets",
      value: "StaticAssets",
    },
    {
      label: "Fluid Assets",
      value: "FluidAssets",
    },
    {
      label: "Rate of Flow",
      value: "FlowRate",
    },
  ],
  TriggerOperator: ["<", ">"],
  alerts_table: [
    {
      align: "start",
      text: "Alert ID",
      value: "AlertID",
      sortable: true,
      of_type: "text",
    },
    {
      text: "POI",
      value: "FullName",
      of_type: "link",
      identifier: "LocationID",
      url: "/location/",
    },
    {
      text: "POI Category",
      value: "LocationCategory",
      of_type: "text",
    },
    {
      text: "Trigger Field",
      value: "TriggerField",
      of_type: "text",
    },

    {
      text: "Trigger Value",
      value: "TriggerValue",
      of_type: "text",
    },
    {
      text: "Trigger Operator",
      value: "TriggerOperator",
      of_type: "text",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["ManageRecipients", "EditDetails", "Delete"],
      labels: ["Manage Recipients", "Edit Details", "Delete"],
    },
  ],
  active_alerts_table: [
    {
      align: "start",
      text: "Alert ID",
      value: "AlertID",
      sortable: true,
      of_type: "text",
    },
    {
      text: "POI",
      value: "FullName",
      of_type: "link",
      identifier: "LocationID",
      url: "/location/",
    },
    {
      text: "POI Category",
      value: "LocationCategory",
      of_type: "text",
    },
    {
      text: "Trigger Field",
      value: "TriggerField",
      of_type: "text",
    },

    {
      text: "Trigger Value",
      value: "TriggerValue",
      of_type: "text",
    },
    {
      text: "Actual Value",
      value: "ActualValue",
      of_type: "text",
    },
    {
      text: "Trigger Date",
      value: "TriggerDate",
      of_type: "date",
    },
  ],
};

export { content };
